/** Created by azhou on 2019/3/13.*/
<template>
    <div>
      <public-title>门店统计报表</public-title>
      <div class="load-area">
        <gcon-search @getSearchCon="getSearchCon" />
        <p v-if="StoreLists.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
            <li class="w-50 list-item-col">
              <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
            </li>
            <li class="w-50 list-item-col" v-if="storeInfo.type == 3 || travel">{{Itemize.order_nos || Itemize.sendNum || 0}}</li>
            <li class="w-50 list-item-col" v-if="storeInfo.type == 3">{{Itemize.offer_nums}}</li>
            <li class="w-50 list-item-col">{{Itemize.success_order_nos || Itemize.dealNum || 0}}</li>
            <li class="w-50 list-item-col">&yen; {{Itemize.success_order_price || Itemize.dealMoney || 0}}</li>
            <li class="w-50 list-item-col" v-if="storeInfo.type == 6 || travel">{{Itemize.success_nums || Itemize.receiveNum || 0}}</li>
            <li class="w-50 list-item-col">&yen; {{Itemize.success_order_pay || Itemize.pay || 0}}</li>
            <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
              {{Itemize.verify | formatVar('verifyType')}}
            </li>
            <li class="w-50 list-item-col">
              {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
            </li>
            <li class="w-50 list-item-col-end">
              <span class="text-link" @click="goForDetail(Itemize)">查看</span>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                         :total="StoreLists.total" :current-page="Number(queryCon.page)"
                         @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'GroupInvoiceList',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      travel () { return this.storeInfo.type == 2 },
      titleArr() {
        switch (this.storeInfo.type) {
          case 2:
            return ['门店名称','发布订单数','成交订单数','成交订单金额','接待人数','累计付款','门店认证','所在地','操作']
            break;
          case 3:
            return ['门店名称','最近三个月匹配','报价次数','成交订单数','成交订单金额','实际收款金额','门店认证','所在地','操作']
            break;
          case 5:
            return ['门店名称','成交订单数','成交订单金额','实际收款金额','门店认证','所在地','操作']
            break;
          case 6:
            return ['景区名称','成交订单数','成交订单金额','接待人次','实际收款金额','门店认证','所在地','操作']
            break;
        }
      }
    },
    watch:{
      queryCon() { 
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {...this.info} })
        else this.groupGetStoreLists({ page:this.queryCon.page, type:7, ...this.info })
      },
    },
    data() {
      return {
        info: {},
        url: '/pc/Travel/storeReport'
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url})
        else this.groupGetStoreLists({ page:this.queryCon.page, type:7 })
      } else {
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1} })
        else this.groupGetStoreLists({ page:1, type:7 })
      }
    },
    methods:{
      ...mapActions(['groupGetStoreLists','TraGroupGetStoreLists']),
      //查看门店统计报表
      goForDetail(item) {
        this.$router.push({name:this.$route.name,query:{page:1,store:item.store_id,GST:item.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        if (this.travel) this.TraGroupGetStoreLists({ url: this.url, data: {page:1, ...info} })
        else this.groupGetStoreLists({ page:1, type:7, ...info })
      }
    }
  }
</script>
